import { observer } from 'mobx-react-lite'

import { EntityHeader, HeaderChip } from '@/Ship/Components/EntityCard'
import { formatPhone } from '@/Ship/Helpers/formatPhone'

import type { ClientFormContextLike } from '../Contracts/IClient'

const firstString = (value: unknown): string | null =>
    Array.isArray(value) && typeof value[0] === 'string' && value[0] !== '' ? value[0] : null

/**
 * Шапка клієнта (`SPEC-009` §8.2) — окремим observer-компонентом: вона читає
 * назву, статус і контакти, які редагують, а ядровий `FormField` на кожне
 * перемальовування шаблону перемонтовує всі поля форми (`SPEC-002` §4.2).
 *
 * Ліворуч — назва й статус бейджем кольору довідника. Праворуч — перший
 * телефон і перша пошта: клік копіює, **без іконки** (правило дизайну карток
 * для CRM). Решта телефонів і пошт — у блоці «Загальне» з кнопкою копіювання.
 */
export const ClientCardHeader = observer(({ formContext }: { formContext: ClientFormContextLike }) => {
    const values = formContext.values ?? {}
    const status = values.status
    const phone = firstString(values.phones)
    const email = firstString(values.emails)
    const title = typeof values.title === 'string' ? values.title : ''

    const contacts =
        phone || email ? (
            <>
                {phone ? <HeaderChip copyText={formatPhone(phone)}>{formatPhone(phone)}</HeaderChip> : null}
                {email ? <HeaderChip copyText={email}>{email}</HeaderChip> : null}
            </>
        ) : undefined

    return (
        <EntityHeader
            status={
                status && typeof status.title === 'string'
                    ? { label: status.title, ...(status.color ? { color: status.color } : {}) }
                    : undefined
            }
            aside={contacts}
            {...(title !== '' ? { title } : {})}
        />
    )
})
